import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  // locale: lStorage.getLang('zh'),  // 语言标识，后面会用做切换和将用户习惯存储到本地浏览器
  locale: 'zh', // 语言标识
  messages: {
    'zh': require('./language/zh'),
    'en': require('./language/en')
  }
})
new Vue({
  router,
  i18n,
  render: h => h(App),
  // mounted() {
  //   setTimeout(()=>{
  //     console.log(this.$route.fullPath)
  //     console.log(JSON.parse(sessionStorage.getItem('offsetTop')))
  //  },230)
  // }
}).$mount('#app')
